module.exports = __webpack_public_path__ + "assets/media/mini_delete_article_icon.dc4bd810.svg";